import url from './url'
let AppConsts = {
	userManagement: {
		defaultAdminUserName: 'admin'
	},
	localization: {
		defaultLocalizationSourceName: 'IDS'
	},
	authorization: {
		encrptedAuthTokenName: 'enc_auth_token'
	},
	appBaseUrl: "http://localhost:8080",
	remoteServiceBaseUrl: url,
	gisAppid: 'grlvnhjzjmgio32t',
	gisSecret: 'kc79c34iz6ma1y89rm5hze5i7niklhkt',
	//gisAuthUrl:'https://gis.yfpo.com:9105/public/sp/sso/yfjwt5?enterpriseId=yf',
	// gisLogout:'https://gis.yfpo.com:9105/public/sp/logout/yfjwt5?enterpriseId=yf&force=true',
	gisAuthUrl: 'https://gis.yfpo.com:9105/sp_sso_login?enterpriseId=yf&redirectUrl=http%3A%2F%2Fgis.yfpo.com%3A9105%2Fenduser%2Fsp%2Fsso%2Fyfjwt5%3FenterpriseId%3Dyf',
	gisLogout: 'https://gis.yfpo.com:9105/sp_sso_login?enterpriseId=yf&redirectUrl=http%3A%2F%2Fgis.yfpo.com%3A9105%2Fenduser%2Fsp%2Fsso%2Fyfjwt5%3FenterpriseId%3Dyf',
	apikey: 'll419i1pwqe4vub7',
	apisecret: 'dnybs5obp5kxr5nwxz0xj00oy8rtnstg',
	salt: '8zspF8C16oh3snOS82FZHk36JChOxOlJ',
	deskey: "DstD3EVx",
	desiv: "3zBvMH4L"
}
if (url.toLocaleLowerCase().indexOf('gistest') > -1) {
	AppConsts = {
		userManagement: {
			defaultAdminUserName: 'admin'
		},
		localization: {
			defaultLocalizationSourceName: 'IDS'
		},
		authorization: {
			encrptedAuthTokenName: 'enc_auth_token'
		},
		appBaseUrl: "http://localhost:8080",
		remoteServiceBaseUrl: url,
		gisAppid: 's3u0iepqj5uusacf',
		gisSecret: 'wpg0p44azeafgz69skk296f2e4psk36k',
		gisAuthUrl: 'https://gistest.yfpo.com:9105/enduser/sp/sso/yfjwt13?enterpriseId=yf',
		gisLogout: 'https://gistest.yfpo.com:9105/sp_sso_login?enterpriseId=yf&redirectUrl=http%3A%2F%2Fgistest.yfpo.com%3A9105%2Fenduser%2Fsp%2Fsso%2Fyfjwt13%3FenterpriseId%3Dyf',
		apikey: 'll419i1pwqe4vub7',
		apisecret: 'dnybs5obp5kxr5nwxz0xj00oy8rtnstg',
		salt: '8zspF8C16oh3snOS82FZHk36JChOxOlJ',
		deskey: "DstD3EVx",
		desiv: "3zBvMH4L"
	}
}

// let AppConsts= {
//     userManagement:{
//         defaultAdminUserName: 'admin'
//     },
//     localization:{
//         defaultLocalizationSourceName: 'IDS'
//     },
//     authorization:{
//         encrptedAuthTokenName: 'enc_auth_token'
//     },
//     appBaseUrl: "",
//     remoteServiceBaseUrl:url,
// 	gisAppid:'grlvnhjzjmgio32t',
// 	gisSecret:'kc79c34iz6ma1y89rm5hze5i7niklhkt',
// 	//gisAuthUrl:'https://gis.yfpo.com:9105/public/sp/sso/yfjwt5?enterpriseId=yf',
// 	// gisLogout:'https://gis.yfpo.com:9105/public/sp/logout/yfjwt5?enterpriseId=yf&force=true',
// 	gisLogout:'/sp_sso_login?enterpriseId=yf&redirectUrl=http%3A%2F%2Fgis.yfpo.com%3A9105%2Fenduser%2Fsp%2Fsso%2Fyfjwt5%3FenterpriseId%3Dyf',	
// 	apikey:'ll419i1pwqe4vub7',
// 	apisecret:'dnybs5obp5kxr5nwxz0xj00oy8rtnstg',
// 	salt:'8zspF8C16oh3snOS82FZHk36JChOxOlJ',
// 	deskey: "DstD3EVx",
// 	desiv: "3zBvMH4L"
// }

export default AppConsts